import debounce from "lodash.debounce";
// 电影座位 逗号分割字符串转数组
export function stringToArray(val) {
    let movie_seat = [];
        if (val) {
            if (val.indexOf(',') != -1) {
            movie_seat = val.split(',');
          } else {
            movie_seat = val.split(' ');
          }
        }
    return movie_seat;
}

//判断对象是否为空
export let isEmpty = (obj) => (Object.keys(obj).length === 0) ? true : false;

//保留n位小数
export function roundFun(value, n=2) {
  if (!value && !n) return;
  let val = parseFloat(value);
  return Math.round(val*Math.pow(10,n))/Math.pow(10,n);
}

//数字是否小于10, 是 => 01/02/03
export function addNumberBeforeZero(num) {
  if (!num) return;
  return num < 10 ? '0' + num : num;
}

//函数节流
export function debounceFn (fn, time) {
  return debounce(fn, time);
}

//依据某个属性 从小到大排序
export function sort(arr=[], attr) {
  function compare (attr) {
    return function (a,b) {
      let val1 = a[attr];
      let val2 = b[attr];
      return val1 - val2;
    }
  }
  arr.sort(compare(attr));
}

//判断是否是中文: true / false
export function judgeChinese(text) {
  // let english = /^[A-Za-z]+$/;
    let chinese = /^[\u4e00-\u9fa5]+$/;
    return chinese.test(text);
}